/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdjacentExhibitorDto } from '../../models/adjacent-exhibitor-dto';

export interface ExhibitorControllerFindAdjacentV1$Params {

/**
 * 참가업체 ID
 */
  id: string;
}

export function exhibitorControllerFindAdjacentV1(http: HttpClient, rootUrl: string, params: ExhibitorControllerFindAdjacentV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AdjacentExhibitorDto>> {
  const rb = new RequestBuilder(rootUrl, exhibitorControllerFindAdjacentV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdjacentExhibitorDto>;
    })
  );
}

exhibitorControllerFindAdjacentV1.PATH = '/api/v1/exhibitor/{id}/adjacent';
